export default "__VITE_ASSET__BuxDYqp5__"